import styled from 'styled-components';

export const Contant = styled.div`
  background-color: ${({ theme }) => theme.white};
  padding: 10px 20px 15px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.grayLight};

  > h6 {
    width: 100%;
    max-width: 600px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 15px 0;

  .MuiInputBase-root.MuiFilledInput-root {
    border: 1px solid ${({ theme }) => theme.grayDark};
  }
  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.pantone2726C};
  }
`;
export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`;

